// Scroll Reveal Animations using Intersection Observer
(function() {
  'use strict';

  // Configuration for the Intersection Observer
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  // Create the observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
      }
    });
  }, observerOptions);

  // Function to initialize scroll reveal
  function initScrollReveal() {
    // Select all elements with scroll reveal classes
    const revealElements = document.querySelectorAll(
      '.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale, .scroll-reveal-rotate, .scroll-reveal-fade'
    );

    // Observe each element
    revealElements.forEach(element => {
      observer.observe(element);
    });
  }

  // Initialize on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Re-initialize when sections are dynamically loaded (for Shopify theme editor)
  document.addEventListener('shopify:section:load', initScrollReveal);
})();
